import * as React from 'react';
import {Form, Button, Alert, FormControlProps, FormControl, Container, Col, Row} from 'react-bootstrap'
import {FaUser, FaLock, FaSpinner} from 'react-icons/fa';
import Auth from '../services/Auth';

export interface ILoginProps {
  onLoggedIn: Function
}

export interface ILoginState {
    login?: String,
    password?: String
    error?: any,
    isWaiting?: boolean
}

export default class Login extends React.Component<ILoginProps, ILoginState> {
  constructor(props: ILoginProps) {
    super(props);
    this.state = {    };
  }

  login = async () =>
  {
    this.setState({
      error: null,
      isWaiting: true
    })

    try{
      await Auth.login({
          accountType: 'USER',
          login: this.state.login as string,
          password: this.state.password as string
        })

      this.props.onLoggedIn();
    } catch(err) {
      this.setState({
        isWaiting: false,
        error:  err && err.error ? err.error : err.toString()
      })
    }
  }

  changeHandler(fieldName: keyof ILoginState) {
    const handleChange = (event: any) => {
        this.setState({
          ... this.state,
          [fieldName]: event.target.value as String
        });
    };
    return handleChange.bind(this);
  }

  public render() {

    const state = this.state;
    const actionAllowed = this.state.password && this.state.login;
    const error = this.state.error;
    return (
        <div style={{height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <Container>
            <Row className="justify-content-md-center">
              <Col xs={12} md={4}>
                <Form className="login-form">
                    <h1 className="login-form-header">ВШЭ платформа кейс тестирования.</h1>
                    <div className="logo"></div>
                    <Form.Group controlId="1">
                        <Form.Label className='control-label'>Email</Form.Label>
                        <FaUser className='login-form-i'/>
                        <Form.Control id="1" placeholder="Введите адрес электронной почты" onChange={this.changeHandler('login')} />
                    </Form.Group>
                    <Form.Group controlId="1">
                        <Form.Label className='control-label'>Password</Form.Label>
                        <FaLock className='login-form-i'/><Form.Control id="2" type="password" placeholder="Введите пароль" onChange={this.changeHandler('password')} />
                    </Form.Group>
                    <Form.Group>
                        <Button className="login-form-button" disabled={!actionAllowed} onClick={this.login}>
                            { !this.state.isWaiting ?
                                <span>Войти</span>
                                :
                                <FaSpinner className='rotate'/>
                                //<FontAwesome name="spinner" spin />
                            }
                        </Button>
                    </Form.Group>
                    { 
                      (() => {
                      return (error ?
                        <Form.Group>
                            <Alert variant='danger'>
                                {error}
                            </Alert>
                        </Form.Group> : null )
                      })()
                    }
                  </Form>
                </Col>
              </Row>
            </Container>
        </div>
    );
  }
}
